import React, { useEffect } from 'react';
import { Form, Input } from 'antd';
import { isChinaMobile } from '@ywfe/utils';
import { ChangePasswordProps } from './auth.interface';

export const ChangePassword: React.FC<ChangePasswordProps> = ({ onChange }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    onChange && onChange(form as any);
  }, []);

  return (
    <Form name="basic" form={form}>
      <Form.Item
        name="userPhone"
        label={<span className="header-item-pw">手机号</span>}
        rules={[
          {
            validator: (_: any, value: string | number) => (isChinaMobile(value) ? Promise.resolve() : Promise.reject('请输入正确的手机号码！')),
          },
        ]}
      >
        <Input
          placeholder="请输入账号绑定手机号码！"
        />
      </Form.Item>
      <Form.Item name="newPassword" label={<span className="header-item-pw">新密码</span>} rules={[{ required: true, message: '请输入新密码!' }]}>
        <Input.Password placeholder="请输入新密码！" />
      </Form.Item>
      <Form.Item
        name="passwordAg"
        dependencies={['newPassword']}
        hasFeedback
        label={<span className="header-item-pw">确认新密码</span>}
        rules={[
          { required: true, message: '确认新密码!' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('newPassword') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('新密码输入不一致！'));
            },
          }),
        ]}
      >
        <Input.Password placeholder="请输入确认新密码!" />
      </Form.Item>
      <Form.Item name="tip" label="">
        密码至少8位，必须包含字母、数字、英文特殊符号（~!@#$%^&*）!
      </Form.Item>
    </Form>
  );
};
